import type { ActualListResponseItem, MonthlyRecord } from '~/composables/performance/kpi/useKpiTypes';

type KpiActualContext = {
  kpiTypeCd?: string;
  accrueMethodCd?: string;
  rateMethodCd?: string;
};

/** performEval / kpiMng actualList(seq 0·1) → DetailPanel 월별 실적 카드 형식 */
export function mapKpiActualListToMonthlyRecords(
  actualList: ActualListResponseItem[] | null | undefined,
  kpi: KpiActualContext = {},
): MonthlyRecord[] {
  if (!actualList?.length) return [];

  const actuals = actualList.filter(item => item.seq === 0 || item.seq === '0');
  const feedbacks = actualList.filter(item => item.seq === 1 || item.seq === '1');

  const accrueMethod = kpi.accrueMethodCd || '001';
  const sortedActuals = [...actuals].sort((a, b) => Number(a.mon) - Number(b.mon));

  const accumMap: Record<string, { accumActual: number; accumRate: number }> = {};
  let runningSum = 0;
  sortedActuals.forEach((item, idx) => {
    const mon = String(item.mon || 1).padStart(2, '0');
    const actual = Number(item.actual) || 0;
    runningSum += actual;

    let accumActual = 0;
    if (accrueMethod === '003') {
      accumActual = actual;
    } else if (accrueMethod === '002') {
      accumActual = parseFloat((runningSum / (idx + 1)).toFixed(2));
    } else {
      accumActual = runningSum;
    }

    const accumRate = Number(item.accrueAchieve) || 0;
    accumMap[mon] = { accumActual, accumRate };
  });

  return actuals.map((item: ActualListResponseItem) => {
    const monthFeedbacks = feedbacks.filter(fb => String(fb.mon) === String(item.mon));
    const mon = String(item.mon || 1).padStart(2, '0');
    const accum = accumMap[mon] || { accumActual: 0, accumRate: 0 };

    return {
      actualId: item.actualId || '',
      actualMon: mon,
      kpiTypeCd: kpi.kpiTypeCd || '01',
      targetVal: Number(item.target) || 0,
      actualVal: item.actual != null && item.actual !== '' ? String(item.actual) : '',
      accumActualVal: accum.accumActual,
      accumAchieveRate: accum.accumRate,
      plan: item.plan || '',
      progress:
        item.achive != null && item.achive !== '' ? String(item.achive).replace(/,/g, '') : '',
      actualDesc: item.actualDescription || item.description || '',
      regDt: item.createDt || item.createDtStr || '',
      status: item.statusCd || '',
      statusNm: item.statusNm || '',
      statusColor: item.statusColor || '',
      atchFileId: item.atchFileId || '',
      atchFileCnt: Number(item.atchFileCnt) || 0,
      feedback:
        monthFeedbacks.length > 0
          ? {
              content: monthFeedbacks[0].actualDescription || '',
              userId: monthFeedbacks[0].userId || '',
              userNm: monthFeedbacks[0].userNm || '',
              posNm: monthFeedbacks[0].posNm || '',
              deptNm: monthFeedbacks[0].deptNm || '',
              createDt: monthFeedbacks[0].createDt || '',
            }
          : null,
    };
  });
}
